// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_avatar__ro4Bn {
  margin: 0 5px;
  cursor: pointer;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_avatar__ro4Bn > div {
  display: flex;
}

.styles_avatar__ro4Bn img {
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Avatar/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AACA;EACE,mBAAA;AAEF","sourcesContent":[".avatar {\n  margin:0 5px;\n  cursor: pointer;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  // aspect-ratio: 1;\n}\n.avatar > div {\n  display: flex;\n}\n.avatar img{\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `styles_avatar__ro4Bn`
};
export default ___CSS_LOADER_EXPORT___;
